var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fast-search-switcher navbar__search",
      class: _vm.searchClasses
    },
    [
      _vm.showNewSearchBar
        ? _c("SearchBar")
        : [
            _vm.showSwitch
              ? _c("CompassSwitch", {
                  attrs: { size: "small" },
                  on: { input: _vm.update },
                  model: {
                    value: _vm.switcher,
                    callback: function($$v) {
                      _vm.switcher = $$v
                    },
                    expression: "switcher"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("fast-search", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.switcher,
                  expression: "switcher"
                }
              ]
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.switcher,
                    expression: "!switcher"
                  }
                ],
                staticClass: "navbar__search-legacy-container",
                class: _vm.legacyClasses
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "click-outside",
                        rawName: "v-click-outside",
                        value: _vm.disableLegacyFocus,
                        expression: "disableLegacyFocus"
                      }
                    ],
                    on: { click: _vm.enableLegacyFocus }
                  },
                  [_vm._t("legacy")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "navbar__search-legacy--close",
                    on: { click: _vm.disableLegacyFocus }
                  },
                  [_c("CompassIcon", { attrs: { icon: "close" } })],
                  1
                )
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }